<template>
  <div class="order-grid col-sm-12 col-md-12 col-lg-12">
    <h1 class="top-title">Account Setup</h1>
    <div class="header2">
      <button class="btn btn-dark" type="button" @click="showAddProv">
        General Information
      </button>
      <!-- <button class="btn btn-dark" type="button" @click="showAccountSection">
        Account Users
      </button> -->
      <button
        class="btn btn-dark"
        type="button"
        id="verifybtn"
        @click="ViewPrivacyConsent"
      >
        Privacy & Consent
      </button>
    </div>
    <div class="createNewUserSec col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <button
        class="btn btn-warning"
        type="button"
        id="createNwUserbtn"
        @click="showUserForm"
      >
        Create New User
      </button>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 addNurseSec">
      <div v-if="showingAdd" class="new-acc-modal">
        <form id="subaccountform" @submit.prevent="addNewAccountUser">
          <div class="mb-2">
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  id="accnttype"
                  class="form-control"
                  v-model="form.accountType"
                  required
                >
                  <option value="">Select account type</option>
                  <option value="Manager">Manager</option>
                  <option value="Licensed Practical Nurse">
                    Licensed Practical Nurse
                  </option>
                  <option value="Registered Nurse">Registered Nurse</option>
                  <option value="Provider">Provider</option>
                </select>
                <label for="AccntRole" class="profile_label">Account Type:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="accountexternid"
                  id="Accntexternid"
                  class="form-control"
                  disabled
                  v-model="form.externid"
                />
                <label for="AccntId" class="profile_label">ID #:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="firstname"
                  id="AccntFname"
                  required
                  class="form-control"
                  placeholder="Required"
                  @keyup="validateName('first')"
                  v-model="form.first"
                />
                <label for="AccntFname" class="profile_label">First Name:</label>
                <div v-if="searchedNpis" id="npinamesearch" class="npinamemodal">
                  <div
                    v-for="(npi, index) in searchedNpis"
                    class="additionalnameli"
                    :key="index + 'npi' + npi.npinumber"
                    @click="selectNpi(npi, index)"
                  >
                    {{ npi.name }}
                  </div>
                </div>
                <form-error
                  v-if="formErrors.first.length != 0"
                  :errors="formErrors.first"
                />
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="lastname"
                  id="AccntLname"
                  class="form-control"
                  placeholder="Required"
                  required
                  @keyup="validateName('last')"
                  v-model="form.last"
                />
                <label for="AccntLname" class="profile_label">Last Name:</label>
                <form-error
                  v-if="formErrors.last.length != 0"
                  :errors="formErrors.last"
                />
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="accountUname"
                  id="AccntpUsername"
                  class="form-control"
                  placeholder="Required"
                  required
                  @keyup="validateUsername"
                  v-model="form.login"
                />
                <label for="AccntUsername" class="profile_label">Username:</label>
                <form-error
                  v-if="formErrors.login.length != 0"
                  :errors="formErrors.login"
                />
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="email"
                  name="accountEmail"
                  id="AccntEmail"
                  required
                  placeholder="Required"
                  class="form-control"
                  @keyup="validateEmail"
                  v-model="form.email"
                />
                <label for="AccntEmail" class="profile_label">Account Email:</label>
                <form-error
                  v-if="formErrors.email.length != 0"
                  :errors="formErrors.email"
                />
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.primaryPhoneType"
                  class="col-12 form-select"
                  required
                >
                  <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">
                    {{ phone.type }}
                  </option>
                </select>
                <label class="profile_label">Phone type</label>
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  id="regphone"
                  class="form-control"
                  v-model="form.primaryPhone"
                  placeholder="Required"
                />
                <label for="mblphone" class="profile_label">Phone Number</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="personalAddress"
                  id="AccntAddress"
                  class="form-control"
                  placeholder="Required"
                  v-model="form.addr"
                />
                <!-- <div
                    v-for="(addr, index) in searchedAddresses"
                    @click="selectAddr(addr, index)"
                    class="additonaladdrli"
                    :key="index"
                  >
                    {{ addr.address }}
                  </div> -->
                <label for="AccntAddress" class="profile_label">Address:</label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  v-model="form.city"
                  type="text"
                  name="personalcity"
                  id="AccntCity"
                  class="form-control"
                  placeholder="Required"
                />
                <label for="AccntCity" class="profile_label">City:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.state"
                  name="personalstate"
                  id="AccntState"
                  class="form-select"
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="AccntState" class="profile_label">State:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  v-model="form.zip"
                  type="text"
                  name="personalzip"
                  id="AccntZip"
                  class="form-control"
                  placeholder="Required"
                />
                <label for="AccntZip" class="profile_label">Zip:</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 npi-container">
              <div class="col-sm-12 col-md-12 col-lg-12 npi-license">
                <label for="Npiproflicense">NPI:</label>
                <input
                  v-model="form.npi"
                  type="text"
                  name="Npipersonalicense"
                  id="AccntNpilicense"
                />
              </div>
              <!--- <div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="NpiAccntdob">Date of Birth:</label><br>
                        <input type="date" name="Npiaccntdob" id="NpiAccntdobd" placeholder="Date of Birth"/>
                    </div>-->
              <!--<div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="NpiAccntSS">last 4 Social Number:</label><br>
                        <input type="text" name="NpiaccountSS" id="NpiAccntSS" placeholder="Last 4 Social Security #"/>
                    </div>-->
            </div>
            <!-- <div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="AccntSS">last 4 Social Number:</label><br>
                        <input type="text" name="accountSS" id="AccntSS" placeholder="Last 4 Social Security #"/>
                    </div>-->
            <div class="row mb-2 gx-2">
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.gender"
                  name="accountGender"
                  id="AccntGender"
                  required
                  class="form-select"
                >
                  <option value="">Please select</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>
                <label for="AccntGender" class="profile_label">Gender:</label>
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <select id="AccntPref" class="form-select" v-model="form.pref">
                  <option value="Email" selected="selected">Email</option>
                  <option value="SMS">SMS</option>
                  <option value="Phone">Phone</option>
                  <option value="All">SMS, Phone & Email</option>
                </select>
                <label for="AccntPref" class="profile_label"
                  >Communication Preference:</label
                >
              </div>
              <div
                v-if="isNurse"
                class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0"
              >
                <input
                  class="form-control"
                  type="text"
                  name="personalicense"
                  id="Accntproflicense"
                  v-model="form.licenseNum"
                />
                <label for="Accntproflicense" class="profile_label"
                  >Professional License:</label
                >
              </div>
              <div
                v-if="isNurse"
                class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0"
              >
                <select
                  v-model="form.licenseSt"
                  name="licensestate"
                  id="LicenseState"
                  class="form-select"
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="AccntState" class="profile_label">License State:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="accountform-btn">
                <input
                  type="submit"
                  class="btn btn-primary"
                  value="Submit New User"
                  id="sbmtuserbtn"
                />
                <input
                  type="button"
                  class="btn btn-secondary"
                  value="Close"
                  id="addnursebtn"
                  @click="CloseaddNurse()"
                />
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="container mt-4 data-tble">
        <h2 v-if="UserAccountData.length != 0">
          ({{ UserAccountData[0].accountnumber }}) - User Accounts
        </h2>
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>User ID</th>
              <th>Username</th>
              <th>Email</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Address</th>
              <th>Phone Number</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(userD, index) in UserAccountData" :key="index">
              <td>
                <div class="col-sm-12 col-md-12 col-lg-12 um-modcontainer">
                  <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                    <img
                      src="https://cdn4.iconfinder.com/data/icons/users-14/128/Users_Circle_Man-512.png"
                      width="50"
                      height="50"
                    />
                  </div>
                  <div class="col-sm-12 col-md-10 col-lg-10">
                    <a href="#elipse" title="Drop Down Menu" :id="'userElipse' + index"
                      >...</a
                    >
                    <div class="um-submenu container">
                      <ul>
                        <li id="premission-link">
                          <a href="#openPrem" title="open premissions" id="premlink"
                            >Premissions</a
                          >
                        </li>
                        <li id="mnguser-link">
                          <a
                            href="#mngUserAccnt"
                            title="Manage User Account"
                            id="mnguserlink"
                            >Manage User Account</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-10 col-lg-10 col-xl-10">
                  <span class="numrec">{{ index }}</span>
                </div>
              </td>
              <td>{{ userD.user_Fname }} {{ userD.user_Lname }}</td>
              <td>{{ userD.user_email }}</td>
              <td>{{ userD.user_Fname }}</td>
              <td>{{ userD.user_Lname }}</td>
              <td>{{ userD.address }},{{ userD.city }}</td>
              <td>{{ userD.user_phone }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { register, isUserExist, isEmailExist } from "@/api/userApi";
import { post } from "@/store/modules/fsm/index";
import us from "us";
import {
  RequestRegistration,
  RegistrationSuccess,
  RegistrationFailure,
  Continue,
} from "@/store/modules/fsm/messages";
import FormError from "@/components/public-layouts/register/FormError";
import { mask } from "vue-the-mask";
import { CURR_API, OTHER_API } from "@/constants/apis";
import $ from "jquery";
import axios from "axios";
import VALIDATION_ERRORS from "@/data/validationErrors";
import genders from "@/data/genders";
import titles from "@/data/titles";
import suffixes from "@/data/suffixes";
import { isNpiExist } from "../../../api/userApi";

export default {
  name: "MyAccount",
  components: {
    "form-error": FormError,
  },
  data() {
    return {
      states: us.states,
      genders,
      showingAdd: false,
      UserAccountData: [],
      allProvs: null, // List of providers already saved for patient
      firstName: "",
      npiSearch: "", // Primary physician search textfield value
      searchedNpis: null, // List of physicians retrieved via npiSearch
      searchedAddresses: null, // List of addresses associated with chosen physician
      editedProv: null, // Provider that is being edited
      textingProv: null,
      txtMsg: "",
      txtPhone: "",
      addedProv: null, // Provider that new account is being made for
      requiredAr: [], //Arry that handles the required fields
      npisAdded: [], // List of npis added for group
      newGroupProvs: [],
      newGroupEmails: [],
      grouplist: [],
      groupNumber: [],
      form: {
        isLoggedIn: false,
        noValidation: true,
        admin: true,
        accountType: "",
        npi: "",
        externid: "",
        externid2: "",
        first: "",
        last: "",
        login: "",
        password: "PACMNYRegister",
        password2: "PACMNYRegister",
        enrollmentId: null,
        dob: "1970-01-01",
        email: "",
        gender: null,
        addr: "",
        city: "",
        state: "",
        zip: "",
        primaryPhoneType: null,
        primaryPhone: null,
        ssn: "",
        pref: "Email",
        licenseNum: "",
        licenseSt: "",
      },
      formErrors: {},
      nwform: {}, //List of Phone numbers
      // patientContacts:null,            //patient contats
      // npi: "",                      // NPI of chosen physician
      // npiAddress: "",               // Address of chosen physician
      // npiPhone: "",                 // Phone number of chosen physician
      // npiFax: "",                   // Fax number of chosen physician
    };
  },
  async mounted() {
    //  this.loadProviders()
    // console.log(this.allProvs)
    //this.addProviders();
    this.getAllAccountusers();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    manager: function () {
      return this.allData.manager;
    },
    relationships: function () {
      return this.allData.relationDescriptions;
    },
    phoneTypes: function () {
      return this.allData.phoneTypes;
    },
    isNurse: function () {
      return (
        this.form.accountType === "Registered Nurse" ||
        this.form.accountType === "Licensed Practical Nurse"
      );
    },
  },
  methods: {
    async getAllAccountusers() {
      let content = {
        Account: {
          accountnumber: this.allData.patient.externId2,
          API_Meth: "GetAccountUsers",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          let jdata = res;
          console.log(jdata);
          //enable the bottun again

          if (jdata.data.status == "Successful") {
            //now set take the payload data object and set it to the Global variable/array
            this.UserAccountData = jdata.data.data;
            console.log(this.UserAccountData);
          } else if (jdata.data.status == "No Records Found") {
            console.log("No Data Found");
            console.log(jdata.data.errors);
            alert("No Users found for this account");
          }
        })
        .catch((err) => {
          console.log(err);
          alert(err.message);
        });
    },
    // createAccount() {
    //   let formData = new FormData(document.getElementById("accform" + this.patient.id));

    //   let loader = this.$loading.show(
    //     {},
    //     {
    //       after: this.$createElement("div", {}, ["Registering your information..."]),
    //     }
    //   );

    //   let form = {
    //     isLoggedIn: true,
    //     noValidation: true,
    //     admin: true,
    //     npi: this.form.npi,
    //     externid: this.form.externid,
    //     externid2: this.allData.patient.externId2,
    //     first: this.form.first,
    //     middle: "",
    //     last: this.form.last,
    //     login: this.form.login,
    //     password: "testing12345",
    //     password2: "testing12345",
    //     enrollmentId: null,
    //     dob: "1970-01-01",
    //     email: this.form.email,
    //     ssnHead: "",
    //     ssnMiddle: "",
    //     ssnTail: "",
    //     gender: this.form.gender,
    //     suffix: null,
    //     title: null,
    //     addr: this.form.addr,
    //     city: this.form.city,
    //     state: this.form.state,
    //     zip: this.form.zip,
    //     cell: this.form.primaryPhone,
    //     work: "",
    //     home: "",
    //     ssn: "",
    //   };
    //   console.log(form);

    //   post({ message: RequestRegistration })
    //     .then(() => {
    //       return register(form);
    //     })
    //     .then((username) => {
    //       if (form.isLoggedIn)
    //         alert(
    //           `Registration success. The username is: "${username}". Please find the verification code in the submitted email`
    //         );
    //       else
    //         alert(
    //           `Registration success. The username is: "${username}". Please find the verification code in the submitted email.`
    //         );
    //       //TODO: redirect to verification page instead
    //       post({ message: RegistrationSuccess });
    //       this.closeNewProv();
    //     })
    //     .catch((err) => {
    //       post({ message: RegistrationFailure });
    //       alert("Registration failure: " + err);
    //     })
    //     .finally(() => {
    //       loader.hide();
    //       loader = null;
    //     });
    // },
    // showAccountSection() {
    //   if ($("#subaccountform").css("display") == "block") {
    //     $("#subaccountform").slideUp("slow");
    //   } else {
    //     //close Provider Group
    //     $("#subaccountform").slideDown("slow");
    //   }
    // },
    ViewPrivacyConsent(event) {
      event.preventDefault();
      alert("show Privacy Alert");
    },
    showUserForm() {
      this.form.externid = Math.floor(Math.random() * 899999999) + 100000000;
      for (let key in this.form) {
        this.$set(this.formErrors, key, []);
      }
      this.showingAdd = true;
    },
    // async addNurse(event) {
    //   event.preventDefault();
    //   let reqar = [];
    //   let fname = $("#nursefname").val();
    //   let lastname = $("#nurselname").val();
    //   let accountnumber = $("#nraccount").val();
    //   let licensenumber = $("#nrlicense").val();
    //   let jurisdiction = $("#nrstate").val();
    //   let nursetype = $("#nursetype").val();
    //   let last4social = $("#nrsocial").val();
    //   let email = $("#nurseemail").val();
    //   let dob = $("#nrdob").val();
    //   // let valfields= this.validateFields();
    //   let msg = "";
    //   if (fname.length < 1) {
    //     reqar.push("firstname");
    //     $(".order-grid").find("#nursefname").css("border-color", "#ff0000");
    //   } else {
    //     $(".order-grid").find("#nursefname").css("border-color", "#000000");
    //   }
    //   if (lastname == "" || lastname.length < 1) {
    //     reqar.push("lastname");
    //     $("#nurselname").css("border-color", "#ff0000");
    //   } else {
    //     $("#nurselname").css("border-color", "#000000");
    //   }
    //   if (accountnumber == "" || accountnumber.length < 1) {
    //     reqar.push("accountnumber");
    //     $("#nraccount").css("border-color", "#ff0000");
    //   } else {
    //     $("#nraccount").css("border-color", "#000000");
    //   }
    //   if (licensenumber == "" || licensenumber.length < 1) {
    //     reqar.push("licensenumber");
    //     $("#nrlicense").css("border-color", "#ff0000");
    //   } else {
    //     $("#nrlicense").css("border-color", "#000000");
    //   }
    //   if (jurisdiction == "" || jurisdiction.length < 1) {
    //     reqar.push("jurisdiction");
    //     $("#nrstate").css("border-color", "#ff0000");
    //   } else {
    //     $("#nrstate").css("border-color", "#000000");
    //   }
    //   if (nursetype == "selected") {
    //     reqar.push("nurstype");
    //     $("#nursetype").css("border-color", "#ff0000");
    //   } else {
    //     $("#nursetype").css("border-color", "#000000");
    //   }
    //   if (last4social == "" || last4social.length < 1) {
    //     reqar.push("last4social");
    //     $("#nrsocial").css("border-color", "#ff0000");
    //   } else {
    //     $("#nrsocial").css("border-color", "#000000");
    //   }
    //   if (email == "" || email.length < 1) {
    //     reqar.push("email");
    //     $("#nurseemail").css("border-color", "#ff0000");
    //   } else {
    //     $("#nurseemail").css("border-color", "#000000");
    //   }
    //   if (dob == "" || dob.length < 1) {
    //     reqar.push("dob");
    //     $("#nrdob").css("border-color", "#ff0000");
    //   } else {
    //     $("#nrdob").css("border-color", "#000000");
    //   }
    //   console.log(reqar);
    //   if (reqar.length > 0) {
    //     msg = "Not Valid";
    //     let alertmsg = "";
    //     alertmsg += "<div id='msgbox'>";
    //     for (var i = 0; i < reqar.length; i++) {
    //       alertmsg += reqar[i] + ",";
    //     }
    //     alertmsg += " fields are required.";
    //     alertmsg += "</div>";
    //     $(".msgbx").html("");
    //     $(".msgbx").append(alertmsg);
    //     $(".msgbx").slideDown("slow");
    //     // return msg;
    //   } else {
    //     msg = "Valid";
    //     $(".msgbx").html("");
    //     $(".msgbx").slideUp("slow");
    //     // return;
    //   }
    //   if (msg == "Valid") {
    //     //disable the button
    //     $("#addnursebtn").attr("disabled", "disabled");
    //     let content = {
    //       ManageNurseList: {
    //         API_Meth: "Add_Nurse",
    //         ncsid: $("#nrnsbid").val(),
    //         jurisdiction: $("#nrstate").val(),
    //         subactioncode: "A", //required
    //         licensnum: $("#nrlicense").val(),
    //         ltype: $("#nursetype").val(),
    //         email: $("#nurseemail").val(),
    //         primephone: $("#primephone").val(),
    //         secondaryphone: $("#secphone").val(),
    //         address1: $("#nraddress").val(), //req
    //         address2: "",
    //         city: $("#nrcity").val(), //req
    //         state: $("#nrstate").val(), //req
    //         zip: $("#nrzip").val(), //req
    //         lastfourssn: $("#nrsocial").val(), //req
    //         bdayear: $("#nrdob").val(), //req
    //         hospitalpracsetting: "21", //req
    //         hostpracsettingother: "",
    //         notficationenabled: "Y", //req
    //         reminderenabled: "Y", //req
    //         locationlist: "",
    //         recid: "",
    //         accountnumber: $("#nraccount").val(),
    //         firstname: $("nursefname").val(),
    //         lastname: $("#nurselname").val(),
    //       },
    //     };
    //     await axios
    //       .post(CURR_API + "/tswebhook.php", content, {
    //         headers: { "Content-Type": "application/json;" },
    //       })
    //       .then((res) => {
    //         console.log(res);
    //         let jdata = res;
    //         console.log(jdata);
    //         //enable the bottun again
    //         $("#addnursebtn").removeAttr("disabled", "disabled");
    //         if (jdata.data.status == "Nurse Added") {
    //           alert(
    //             "Nurse" +
    //               " " +
    //               $("#nursefname").val() +
    //               " " +
    //               $("#nurselname").val() +
    //               " Successfully Added"
    //           );
    //           //now close SMS Canvas

    //           let ask = confirm(
    //             "Nurse has been verified, would you like to add them to your account?"
    //           );
    //           if (ask == true) {
    //             //lets now add them to our internal database

    //             this.AddInternalNurse();
    //             //now load list of nurse
    //             this.loadProviders();
    //             //clear out the form
    //             $("#nursefname").val();
    //             $("#nurselname").val("");
    //             $("#nraccount").val("");
    //             $("#nrlicense").val("");
    //             $("#nrstate").val("");
    //             $("#nursetype").val("");
    //             $("#nrsocial").val("");
    //             $("#nurseemail").val("");
    //             $("#nrdob").val("");
    //             $("#nraddress").val("");
    //             $("#nrcity").val("");
    //             $("#nrzip").val("");
    //             $("#nraccount").val("");
    //           }
    //         } else if (jdata.data.status == "Nurse Not Added") {
    //           console.log("Issue");
    //           console.log(jdata.data.errors[0]);
    //           alert("Nurse wasn't added to the system. Please check data and try again");
    //         }
    //       });
    //   } else {
    //     alert("Missing Required Fields. Please reveiw and try again.");
    //   }
    // },
    // async AddInternalNurse() {
    //   let content = {
    //     ManageNurseList: {
    //       API_Meth: "InternalAddNurse",
    //       ncsid: $("#nrnsbid").val(),
    //       jurisdiction: $("#nrstate").val(),
    //       subactioncode: "A", //required
    //       licensnum: $("#nrlicense").val(),
    //       ltype: $("#nursetype").val(),
    //       email: $("#nurseemail").val(),
    //       primearyphone: $("#primephone").val(),
    //       secondaryphone: $("#secphone").val(),
    //       address1: $("#nraddress").val(), //req
    //       address2: "",
    //       city: $("#nrcity").val(), //req
    //       state: $("#nrstate").val(), //req
    //       zip: $("#nrzip").val(), //req
    //       lastfourssn: $("#nrsocial").val(), //req
    //       bdayear: $("#nrdob").val(), //req
    //       hospitalpracsetting: "21", //req
    //       hostpracsettingother: "",
    //       notficationenabled: "Y", //req
    //       reminderenabled: "Y", //req
    //       locationlist: "",
    //       recid: "",
    //       accountnumber: $("#nraccount").val(),
    //       firstname: $("#nursefname").val(),
    //       lastname: $("#nurselname").val(),
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       if (res.data.message == "Inserted") {
    //         alert("Nurse Added to the system successfully!");
    //         //now close SMS Canvas
    //       } else if (res.data.message == "Record Exist") {
    //         alert(
    //           $("#nursefname").val() +
    //             " " +
    //             $("#nurselname").val() +
    //             ", already Exist in our System. You may want to edit or update Nurses Information from the Nurses section."
    //         );
    //       } else {
    //         alert(res.message);
    //         console.log("Nurses not added successfully");
    //       }
    //     });
    // },
    // async InternalProviderLookUp(provname) {
    //   this.npiSearch = provname;
    //   let results = this.showResults();
    //   console.log(results);
    // },
    CloseaddNurse() {
      this.showingAdd = false;
    },
    async addNewAccountUser() {
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      let loader = this.$loading.show(
        {
          container: this.$refs.pageBody,
        },
        {
          after: this.$createElement("div", {}, [`Creating account...`]),
        }
      );
      //this.nwform.accountnumber= Math.floor(Math.random() * (899999999)) + 100000000;

      this.nwform.cell = this.form.primaryPhone; //$("#regphone").val();
      //this.nwform.accountnumber= Math.floor(Math.random() * (899999999)) + 100000000;//Okay I don't need this anymore because I Should be able to grab this from App State
      this.nwform.accountnumber = this.allData.patient.externId2;
      this.nwform.accountrole = "Administrator";
      this.nwform.Firstname = this.form.first;
      this.nwform.Lastname = this.form.last;
      this.nwform.Address = this.form.addr;
      this.nwform.prCity = this.form.city;
      this.nwform.prState = this.form.state;
      this.nwform.prZip = this.form.zip;
      this.nwform.accountType = this.form.accountType;
      this.nwform.commpref = this.form.pref;
      this.nwform.license = this.form.licenseNum;
      this.nwform.practicestate = this.form.licenseSt;
      this.nwform.dob = this.form.dob;
      this.nwform.gender = this.form.gender;
      this.nwform.username = this.form.login;
      this.nwform.password = this.form.password;
      this.nwform.email = this.form.email;
      this.nwform.externalid2 = this.form.externid;
      this.nwform.uniqueNineID = this.form.externid;

      this.form.externid2 = this.nwform.accountnumber;
      console.log(this.form);

      register(this.form)
        .then((data) => {
          if (data.externid && data.externid != "") {
            let crtAcnt = this.SendAccountInfo().then((x) => {
              this.getAllAccountusers();
              loader.hide();
              this.$swal({
                type: "success",
                title: "Success",
                text:
                  "This account has been created. It must now be verified before it can be used.",
              });
            });
          } else {
            alert("Something wrong with register function");
            console.log(data);
            loader.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Caught exception for register function");
        });
    },
    validateName(nameType) {
      //TODO: only letters are allowed at the moment
      const nameRegex = new RegExp("^([a-zA-Z])+([ a-zA-Z])*$");
      let error = null;

      this.form[nameType] = this.form[nameType].trim();
      this.formErrors[nameType] = [];
      if (this.form[nameType] !== "" && !nameRegex.test(this.form[nameType])) {
        error = VALIDATION_ERRORS.LETTERS_ONLY;
        this.$set(this.formErrors[nameType], this.formErrors[nameType].length, error);
      }
    },
    validateUsername() {
      const usernameRegex = new RegExp("^([a-zA-Z]|_)+([a-zA-Z0-9_])*$");
      let error = null;

      this.form.login = this.form.login.trim();
      this.formErrors.login = [];
      //TODO: send ajax to check if username exist?
      if (!usernameRegex.test(this.form.login)) {
        error = VALIDATION_ERRORS.USERNAME_CHARACTERS;
        this.$set(this.formErrors.login, this.formErrors.login.length, error);
      }
      if (this.form.login.length < 8 || this.form.login.length > 24) {
        error = VALIDATION_ERRORS.USERNAME_LENGTH;
        this.$set(this.formErrors.login, this.formErrors.login.length, error);
      }
      if (this.formErrors.login.length < 1) {
        isUserExist(this.form.login)
          .then((userExists) => {
            if (userExists) {
              error = VALIDATION_ERRORS.USERNAME_EXISTS;
              this.$set(this.formErrors.login, this.formErrors.login.length, error);
            }
          })
          .catch((err) => {
            alert(err);
          });
      }
      return true;
    },
    validateEmail() {
      let error = null;
      isEmailExist(this.form.email)
        .then((exists) => {
          if (exists) {
            error = VALIDATION_ERRORS.EMAIL_EXISTS;
            this.$set(this.formErrors.email, this.formErrors.email.length, error);
          } else {
            this.formErrors.email = [];
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    validate() {
      for (let key in this.formErrors) {
        if (this.formErrors[key] && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    // ValidateSubForm(Firstname, Lastname, email, Address, prCity, prState, prZip, dob) {
    //   let varar = [];
    //   if ($("#AccntFname").val() == "") {
    //     $("#AccntFname").css("border-color", "#FF0000");
    //     varar.push("Firstname");
    //   } else {
    //     $("#AccntFname").css("border-color", "#000000");
    //   }
    //   if ($("#AccntLname").val() == "") {
    //     $("#AccntLname").css("border-color", "#FF0000");
    //     varar.push("Lastname");
    //   } else {
    //     $("#AccntLname").css("border-color", "#000000");
    //   }
    //   if ($("#AccntEmail").val() == "") {
    //     $("#AccntEmail").css("border-color", "#FF0000");
    //     varar.push("Email");
    //   } else {
    //     $("#AccntEmail").css("border-color", "#000000");
    //   }
    //   if ($("#AccntAddress").val() == "") {
    //     $("#AccntAddress").css("border-color", "#FF0000");
    //     varar.push("Address");
    //   } else {
    //     $("#AccntAddress").css("border-color", "#000000");
    //   }
    //   if ($("#AccntCity").val() == "") {
    //     $("#AccntCity").css("border-color", "#FF0000");
    //     varar.push("City");
    //   } else {
    //     $("#AccntCity").css("border-color", "#000000");
    //   }
    //   if ($("#AccntState").val() == "") {
    //     $("#AccntState").css("border-color", "#FF0000");
    //     varar.push("State");
    //   } else {
    //     $("#AccntState").css("border-color", "000000");
    //   }
    //   if ($("#AccntZip").val() == "") {
    //     $("#AccntZip").css("border-color", "#FF0000");
    //     varar.push("Zip");
    //   } else {
    //     $("#AccntZip").css("border-color", "#000000");
    //   }
    //   if ($("#Accntdobd").val() == "") {
    //     $("#Accntdobd").css("border-color", "#FF0000");
    //     varar.push("Date of Birth");
    //   } else {
    //     $("#Accntdobd").css("border-color", "#000000");
    //   }
    //   console.log(varar.length);
    //   if (varar.length > 0) {
    //     //now loop through the array and set the Valiation Errors
    //     // let htmlMsg ="<div class='formmsg col-sm-12 col-md-12 col-lg-12'>";
    //     let htmlMsg = "<p class='validation'>";
    //     for (var i = 0; i < varar.length; i++) {
    //       switch (varar[i]) {
    //         case "Firstname": {
    //           // htmlMsg +="<p class='validation'>Business Name Required.</p>";
    //           htmlMsg += "First Name required, ";
    //           break;
    //         }
    //         case "Lastname": {
    //           //htmlMsg +="<p class='validation'>Ein Required.</p>";
    //           htmlMsg += "Lastname required,";
    //           break;
    //         }
    //         case "Email": {
    //           // htmlMsg +="<p class='validation'>Business Address Required.</p>";
    //           htmlMsg += "Email address required, ";
    //           break;
    //         }
    //         case "Address": {
    //           // htmlMsg +="<p class'validation'>Billing City Required.</p>";
    //           htmlMsg += "Address required, ";
    //           break;
    //         }
    //         case "City": {
    //           // htmlMsg +="<p class'validation'>Billing State Required.</p>";
    //           htmlMsg += "City required, ";
    //           break;
    //         }
    //         case "State": {
    //           //htmlMsg +="<p class'validation'>Billing Zip Required.</p>";
    //           htmlMsg += "State required, ";
    //           break;
    //         }
    //         case "Zip": {
    //           //htmlMsg +="<p class'validation'>Credit Card Name Required.</p>";
    //           htmlMsg += "Zip required, ";
    //           break;
    //         }
    //         case "Date of Birth": {
    //           htmlMsg += "Date of Birth";
    //           break;
    //         }
    //       }
    //     }
    //     htmlMsg += "</p>";
    //     // htmlMsg +="</div>";
    //     //lets append to the Formmsg iD
    //     // $("#formMsg").html('');
    //     $("#msgbox").append(htmlMsg);
    //     $("#msgbox").css("display", "block");
    //     let msgerr = ["form error", varar];
    //     console.log(msgerr);
    //     return msgerr;
    //   } else {
    //     $("#msgbox").css("display", "none");
    //     let msgsuccess = ["form validated", varar];
    //     return msgsuccess;
    //   }
    // },
    // ValidatePreRequirementFields() {
    //   let valar = [];
    //   //Lets check the Pre-Required Fields and if they are empty push Empty field into valar array
    //   if ($("#Accntdobd").val() == "") {
    //     valar.push("Date of Birth");
    //     $("#Accntdob").css("border-color", "#FF0000");
    //   } else {
    //     $("#Accntdob").css("border-color", "#FF0000");
    //   }
    //   if ($("#AccntSS").val() == "") {
    //     valar.push("Social Number");
    //     $("#AccntSS").css("border-color", "#FF0000");
    //   } else {
    //     $("#AccntSS").css("border-color", "#000000");
    //   }
    //   if ($("#AccntGender").val() == "") {
    //     valar.push("Gender");
    //     $("#AccntGender").css("border-color", "#FF0000");
    //   } else {
    //     $("#AccntGender").css("border-color", "#000000");
    //   }
    //   if ($("#accnttype").val() == "") {
    //     valar.push("Account Type");
    //     $("#accnttype").css("border-color", "#FF0000");
    //   } else {
    //     $("accnttype").css("border-color", "#000000");
    //   }
    //   switch ($("#accnttype").val()) {
    //     case "Nurse": {
    //       if ($("#Accntproflicense").val() == "") {
    //         valar.push("Professional License");
    //         $("#Accntproflicense").css("border-color", "#FF0000");
    //       } else {
    //         $("Accntproflicense").css("border-color", "#000000");
    //       }
    //       break;
    //     }
    //     case "Provider": {
    //       if ($("#AccntNpilicense").val() == "") {
    //         valar.push("Professional License");
    //         $("#AccntNpilicense").css("border-color", "#FF0000");
    //       } else {
    //         $("AccntNpilicense").css("border-color", "#000000");
    //       }
    //       break;
    //     }
    //   }

    //   if ($("#AccntFname").val() == "") {
    //     valar.push("Firstname");
    //     $("#AccntFname").css("border-color", "#FF0000");
    //   } else {
    //     $("#AccntFname").css("border-color", "#000000");
    //   }
    //   if ($("#AccntLname").val() == "") {
    //     valar.push("Lastname");
    //     $("#AccntLname").css("border-color", "#FF0000");
    //   } else {
    //     $("#AccntLname").css("border-color", "#000000");
    //   }

    //   if ($("#AccntpUsername").val() == "") {
    //     valar.push("Username");
    //     $("#AccntpUsername").css("border-color", "#FF0000");
    //   } else {
    //     $("#AccntpUsername").css("border-color", "#000000");
    //   }
    //   if ($("#AccntPWord").val() == "") {
    //     valar.push("Password");
    //     $("#AccntPWord").css("border-color", "#FF0000");
    //   } else {
    //     $("#AccntPWord").css("border-color", "#000000");
    //   }

    //   if ($("#AccntEmail").val() == "") {
    //     valar.push("Email");
    //     $("#AccntEmail").css("border-color", "#FF0000");
    //   } else {
    //     $("#AccntEmail").css("border-color", "#000000");
    //   }

    //   console.log(valar);
    //   if (valar.length > 0) {
    //     //form issues so lets loop through and build the form error msg
    //     let htmlMsg = "<div class='formmsg col-sm-12 col-md-12 col-lg-12'>";
    //     htmlMsg += "<p class='validation'>";
    //     for (var i = 0; i < valar.length; i++) {
    //       switch (valar[i]) {
    //         case "Firstname": {
    //           // htmlMsg +="<p class='validation'>*First Name required field.</p>";
    //           htmlMsg += "*First Name required, ";
    //           break;
    //         }
    //         case "Lastname": {
    //           // htmlMsg +="<p class='validation'>*Last Name required field.</p>";
    //           htmlMsg += "* Last Name required, ";
    //           break;
    //         }
    //         case "Username": {
    //           //htmlMsg +="<p class='validation'>*Username required.</p>";
    //           htmlMsg += "*Username required, ";
    //           break;
    //         }
    //         case "Password": {
    //           // htmlMsg +="<p class='validation'>*Password required.</p>";
    //           htmlMsg += "Password required,";
    //           break;
    //         }
    //         case "Email": {
    //           //htmlMsg +="<p class='validation'>*Email required.</p>";
    //           htmlMsg += "Email required";
    //           break;
    //         }
    //         case "Date of Birth": {
    //           //htmlMsg +="<p class='validation'>*Email required.</p>";
    //           htmlMsg += "Dob required";
    //           break;
    //         }
    //         case "Social Number": {
    //           //htmlMsg +="<p class='validation'>*Email required.</p>";
    //           htmlMsg += "Social Number required";
    //           break;
    //         }
    //         case "Gender": {
    //           //htmlMsg +="<p class='validation'>*Email required.</p>";
    //           htmlMsg += "Gender required";
    //           break;
    //         }
    //         case "Account Type": {
    //           //htmlMsg +="<p class='validation'>*Email required.</p>";
    //           htmlMsg += "Account Type required";
    //           break;
    //         }
    //         case "Professional License": {
    //           //htmlMsg +="<p class='validation'>*Email required.</p>";
    //           htmlMsg += "Professional License";
    //           break;
    //         }
    //       }
    //     }
    //     //lets close html
    //     htmlMsg += "</p>";
    //     htmlMsg += "</div>";
    //     //lets append to the Formmsg iD
    //     $("#msgbox").html("");
    //     $("#msgbox").append(htmlMsg);
    //     $("#msgbox").css("display", "block");
    //     let msg = ["form error", valar];
    //     return msg;
    //   } else {
    //     //
    //     $("#msgbox").html("");
    //     $("#msgbox").css("display", "none");
    //     let msg = ["form validated", "validated"];
    //     return msg;
    //   }
    // },

    randomId() {
      return Math.floor(Math.random() * 899999999) + 100000000;
    },
    async showNPIResults() {
      let content = {
        methname: "GetAllInfo",
        primphysician: $("#AccntFname") > val() + $("#AccntLname").val(),
      };
      // this.showPreloader()
      await axios
        .post(CURR_API + "/NPILookup.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.results && res.data.results == "No Results Found") {
            this.searchedNpis = null;
          } else this.searchedNpis = res.data;
        });
      // this.stopPreloader()
    },
    async SendAccountInfo() {
      //now lets send over values to be saved on the serv er
      let content = {
        Account: {
          API_Meth: "CreateSubAccount",
          Formdata: this.nwform,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "Account Created Successfully") {
            alert("SubAccount Created successfully");
            this.getAllAccountusers();
            //now run the email notification to bth the admin and the user
            this.SendSubAccountEmail();
            //return msg;
          } else {
            //I would process error from the API here that are inline with the Account Setup on the backend
            console.log(res.data);
            alert("Account Not Created Successfully");
          }
        })
        .catch((err) => {
          console.log(err);
          let jdata = JSON.parse(err);
          alert(jdata); //spit out the error
          alert("Error" + " " + err.data);
          console.log("Error" + " " + jdata);
          msg = "Error with the Promise";
          return msg;
        });
    },
    async UpdateNewUser() {
      let content = {
        ManageNurseList: {
          API_Meth: "InternalAddNurse",
          ncsid: $("#nrnsbid").val(),
          jurisdiction: $("#nrstate").val(),
          subactioncode: "A", //required
          licensnum: $("#nrlicense").val(),
          ltype: $("#nursetype").val(),
          email: $("#nurseemail").val(),
          primearyphone: $("#primephone").val(),
          secondaryphone: $("#secphone").val(),
          address1: $("#nraddress").val(), //req
          address2: "",
          city: $("#nrcity").val(), //req
          state: $("#nrstate").val(), //req
          zip: $("#nrzip").val(), //req
          lastfourssn: $("#nrsocial").val(), //req
          bdayear: $("#nrdob").val(), //req
          hospitalpracsetting: "21", //req
          hostpracsettingother: "",
          notficationenabled: "Y", //req
          reminderenabled: "Y", //req
          locationlist: "",
          recid: "",
          accountnumber: $("#nraccount").val(),
          firstname: $("#nursefname").val(),
          lastname: $("#nurselname").val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "Inserted") {
            alert("Nurse Added to the system successfully!");
            //now close SMS Canvas
          } else if (res.data.message == "Record Exist") {
            alert(
              $("#nursefname").val() +
                " " +
                $("#nurselname").val() +
                ", already Exist in our System. You may want to edit or update Nurses Information from the Nurses section."
            );
          } else {
            alert(res.message);
            console.log("Nurses not added successfully");
          }
        });
    },

    ShowGroupList(index) {
      if ($("#accordionbottom" + index).css("display") == "block") {
        $("#accordionbottom" + index).slideUp("slow");
      } else {
        //close the Add Group Section

        $("#accordionbottom" + index).slideDown("slow");
      }
    },
    async DeleteUserAccount(index) {
      //lets get the group name
      alert("Delete Account Here");
      let groupname = $("#deletegrp" + index)
        .closest(".card")
        .find("#gpname")
        .html();
      console.log(groupname);
      let content = {
        Provider: {
          API_Meth: "DeleteAccountUser",
          accountnumber: this.allData.patient.externId2,
          uniquenine: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == "200" && res.data.message == "Deleted") {
            alert(
              $("#deletegrp" + index)
                .closest(".card")
                .find("#gpname")
                .html() + " has been successfully deleted!"
            );
          }
        });
    },

    async loadAccountUsers() {
      let content = {
        Account: {
          API_Meth: "GetAccountUsers",
          accountnumber: "45000",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data) {
            this.allProvs = res.data.nurseInfo;
          } else {
            this.allProvs = null;
          }
        });
    },

    async SendSubAccountEmail() {
      let mcontent = {
        Account: {
          API_Meth: "SendNewSubAccountEmail", ///Api Method to call
          accountnumber: this.allData.patient.externId2, //account number
          uniquenine: this.nwform.uniqueNineID, //user unique nine
          accounttype: this.form.accountType,
          accountholder: this.form.first + " " + this.form.last,
          usertoemail: this.form.email,
          firstname: this.form.first,
          lastname: this.form.last,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", mcontent, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          console.log(res.data);
          console.log(res.data.status);

          if (res.data.status && res.data.status == "Successfull") {
            alert(
              "Account Email Notifcation has been Successfully Sent to both Administrator and the User."
            );
            //now hide the UI
          }
        })
        .catch((err) => {
          alert(err);
          console.log(err);
        });
    },

    async showResults() {
      let content = {
        methname: "GetAllInfo",
        primphysician: this.npiSearch,
      };
      // this.showPreloader()
      await axios
        .post(CURR_API + "/NPILookup.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.results && res.data.results == "No Results Found") {
            this.searchedNpis = null;
            alert("No Search Results Found");
          } else {
            this.searchedNpis = res.data;
          }
        })
        .catch((err) => {
          alert(err);
          console.log(err);
        });
      // this.stopPreloader()
    },

    showAddProv() {
      if ($(".nurseSettingSec").css("display") == "block") {
        $(".nurseSettingSec").slideUp("slow");
        $(".result-list").slideDown("slow");
      } else {
        if ($("#nurseform").css("display") == "block") {
          $("#nurseform").slideUp("slow");
        }
        $(".result-list").slideUp("slow");
        $(".nurseSettingSec").slideDown("slow");
        //hide nurses cards
      }
    },

    selectNpi(npi, index) {
      /* console.log(npi.addresses[index].address);
           console.log(npi.addresses[index].address);
            let splitaddr = npi.addresses[index].address;
            let splitaddr2 = splitaddr.split(",");
            console.log(splitaddr2);
            let finaladdr = splitaddr2[0];
            let finalcity = splitaddr2[1];
            let finalstate = splitaddr2[2];
            let finalzip = splitaddr2[3];
            $("#AccntAddress").val(finaladdr);
            $("#AccntAddress").text(finaladdr);*/
      $("#AccntNpilicense").val(npi.npinumber);
      let name = npi.name.trim().split(" ");
      console.log(name[0]);
      console.log(name[1]);
      let entirename = $("#AccntFname").val();
      console.log(entirename);
      let nwname = entirename.split(" ");
      console.log(nwname);
      this.searchedNpis = nwname[0];
      $("#AccntLname").val("");
      $("#AccntFname").text("");
      $("#AccntFname").attr("value", nwname[0]);
      $("#AccntLname").attr("value", nwname[1]);
      $("#AccntFname").text(nwname[0]);
      $("#AccntLname").text(nwname[1]);
      $("#AccntFname").val(nwname[0]);
      $("#AccntLname").val(nwname[1]);
      console.log($("#AccntFname").text() + " " + $("#AccntLname").text());

      this.searchedNpis = null;
      this.searchedAddresses = npi.addresses;
    },
    async saveProv() {
      let callnumexist = "";
      let isemailValid = "";
      if ($("#phytel").val() != "" || $("#phycell").val() != "") {
        callnumexist = "true";
      } else {
        callnumexist = "false";
      }
      //valdate email
      let re = /^\w+([-+.'][^\s]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

      let emailFormat = re.test($("#phyemail").val()); // This return result in Boolean type
      console.log(emailFormat);
      if (emailFormat) {
        isemailValid = true;
      } else {
        isemailValid = false;
      }
      if (
        $("#phyfirstname").length != 0 &&
        $("#phylastname").length != 0 &&
        $("#phytel").length != 0 &&
        $("#phyemail").length != 0 &&
        isemailValid == true &&
        callnumexist == "true"
      ) {
        let form = document.getElementById("provform" + this.patient.id);
        let modal = document.getElementById("provmodal" + this.patient.id);
        let content = {
          Provider: {
            API_Meth: "AddProvider",
            provFname: form.elements["phyfirstname"].value,
            provLname: form.elements["phylastname"].value,
            provAddr1: form.elements["phyaddr"].value,
            provAddr2: "",
            provCity: "",
            provState: "",
            provZip: "",
            provTel: form.elements["phytel"].value,
            provCell: form.elements["phycell"].value,
            provFax: form.elements["phyfax"].value,
            npinumber: form.elements["phynpi"].value,
            pid: this.patient.externId,
            ordernumber: "999",
            status: "Active",
            provEmail: form.elements["phyemail"].value,
          },
        };
        console.log(content);
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);
            if (res.data.message && res.data.message == "Inserted") {
              this.npiSearch = null;
              this.searchedNpis = null;
              this.searchedAddresses = null;
              this.loadProviders();

              alert("Provider successfully added");
              form.reset();
              modal.style.display = "none";
            } else {
              alert(
                "Error with provider insertion. Try again or contact an administrator."
              );
            }
          });
      } else {
        alert(
          "Please ensure the form field requirements has been met. Please check your entries and try again."
        );
      }
    },
    async saveEditProv() {
      let form = document.getElementById("edit-prov-form-" + this.patient.id);
      let modal = document.getElementById("edit-prov-modal-" + this.patient.id);
      let content = {
        Provider: {
          API_Meth: "UpdateProvider",
          providerid: this.editedProv.providerid,
          email: "",
          patientid: this.patient.externId,
          ordernumber: "",
          firstname: form.elements["phyfirstname"].value,
          lastname: form.elements["phylastname"].value,
          address1: form.elements["phyaddr"].value,
          address2: "",
          city: "",
          state: "",
          zip: "",
          phone: form.elements["phytel"].value,
          cell: form.elements["phycell"].value,
          email: form.elements["phyemail"].value,
          fax: form.elements["phyfax"].value,
          npinumber: form.elements["phynpi"].value,
          status: "Active",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.msg && res.data.msg == "Updated") {
            this.loadProviders();
            alert("Provider successfully edited");
            this.editedProv = null;
            // form.style.display = "none"
            // modal.style.display = "none"
          } else {
            alert(res.data[1]);
          }
        });
    },
    selectAddr(addr, index) {
      console.log(addr.address);
      let naddr = addr.address.split(",");
      console.log(naddr);
      // document.querySelector("#AccntAddress").value =naddr[0];
      alert(naddr[0]);
      $("#AccntAddress").val(naddr[0]);
      document.querySelector("#AccntAddress").value = naddr[0];
      let splitcity = naddr[1].split(" ");
      console.log(splitcity);
      $("#AccntCity").val(splitcity[0]);
      $("#AccntState").val(splitcity[1]);
      $("#AccntZip").val(splitcity[2]);
      document.querySelector("#regphone").value = addr.tel ? addr.tel : "";
      //document.querySelector("#phyfax").value = addr.fax ? addr.fax : ""
      this.searchedAddresses = null;
    },
    closeProv() {
      let form = document.getElementById("provform" + this.patient.id);
      form.reset();
      this.npiSearch = null;
      this.searchedAddresses = null;
      this.searchedNpis = null;
      let modal = document.getElementById("provmodal" + this.patient.id);
      modal.style.display = "none";
    },
    closeEditProv() {
      let form = document.getElementById("edit-prov-form-" + this.patient.id);
      form.reset();
      this.npiSearch = null;
      this.searchedAddresses = null;
      this.searchedNpis = null;
      this.editedProv = null;
      let modal = document.getElementById("edit-prov-modal-" + this.patient.id);
      modal.style.display = "none";
    },
    closeNewProv() {
      let form = document.getElementById("accform" + this.patient.id);
      form.reset();
      this.addedProv = null;
    },
  },
};
</script>
<style scoped lang="scss">
// .form-group {
//   margin-bottom: 20px;
//   width: 100%;
// }

// .form-group label {
//   display: block;
//   margin-bottom: 5px;
//   font-weight: 600;
//   font-size: 14px;
// }
.um-modcontainer {
  display: flex;
  text-align: center;
}
.um-submenu.container {
  max-width: 250px;
  /*background-color: #fff;*/
  margin: 0px 20px;
  height: auto;
  /* padding-bottom: 5px;*/
  z-index: 1000;
}
.um-submenu {
  display: none;
}
.um-submenu.container:hover {
  display: block;
}
.createNewUserSec {
  display: flex;
  flex-direction: row-reverse;
}
.new-user-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: none;
  justify-content: center;
  align-items: center;
}

.npinamemodal {
  z-index: 20000;
}
#createNwUserbtn {
  margin-right: 30px;
  height: 55px;
  background-color: #f0a10f;
  color: #fff;
  font-weight: 600;
}
.nursefield-container {
  display: none; //needs to be flex on Aaccount type
  flex-direction: horizontal;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.npi-container {
  display: none; //needs to be flex if the account type is changed to Provider
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.edit-prov-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.nurseform-btn {
  display: flex;
  align-items: space-evenly;
}
#nurseform {
  display: none;
}
#nurseform .msgbx {
  display: none;
  background-color: red;
  color: #fff;
  font-size: 18px;
  padding: 10px;
  margin-bottom: 10px;
  word-break: break-word;
}
.top-title {
  text-align: center;
  color: #0060ff;
}

.new-acc-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.send-text-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.new-acc-modal form {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 50%;
  width: 100%;
}

.new-prov-modal form {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.inner-text-modal {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

// .form-group {
//   margin-bottom: 20px;
// }

// .form-group label {
//   display: block;
//   margin-bottom: 5px;
//   font-weight: 600;
//   font-size: 14px;
// }

// .form-control {
//   display: block;
//   width: 100%;
//   height: 40px;
//   padding: 10px;
//   font-size: 16px;
//   border: 1px solid #ccc;
//   border-radius: 5px;
//   box-shadow: none;
// }

.btn-group {
  display: flex;
  justify-content: flex-end;
}
// .form-control.prvtxtMsgbox {
//   border-style: solid;
//   border-color: #000000;
//   height: 140px;
// }
.btn-primary,
.btn-secondary {
  height: 40px;
  padding: 0 20px;
}

.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #0060ff;
}

.title {
  margin-right: 20px;
}

.result-list {
  width: 700px;
}

.result-item {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 2em auto 0;
  text-align: left;
}

.result-item:first-child {
  margin-top: 1em;
}

.header3 {
  text-align: center;
  color: #fff;
  font-size: 1.2em;
  padding: 5px 0;
  background-color: #007bff;
}

.capitalize {
  text-transform: capitalize;
}

.result-item-link {
  display: block;
  text-align: right;
  font-size: 0.85em;
}

ul {
  list-style-type: none;
  margin: 0 auto;
}
.providerGroup-listcard {
  display: flex;
  justify-content: space-evenly;
  border-style: dashed;
  border-width: 1px;
  width: 100%;
}
/*Keyon Add Provider CSS*/
#nurseform .form-container {
  display: flex;
  flex-direction: column;
  max-width: 700px;
}
// .form-container input {
//   margin-bottom: 10px;
// }
// .form-container select {
//   width: 95%;
//   height: 42px;
// }

#nursetype {
  margin-bottom: 10px;
}
.provcardSec {
  display: none;
  align-items: center;
  position: relative;
  flex-direction: column;
}
.emailcanvas {
  display: none;
}

#cllprov {
  margin-left: 20px;
}
#providetomail {
  margin-left: 30px;
}
#provemailsubject {
  margin-left: 30px;
}
#provid-emailmsg {
  margin-left: 30px;
  margin-top: -10px;
  margin-bottom: 10px;
  width: 400px;
  height: 100px;
}
#sendprovid-emailbtn {
  margin-left: 30px;
}
.emailcanvas .container {
  box-shadow: 1px 1px 9px #5f5852;
  position: absolute;
  background-color: #ffffff;
  width: 855px;
  height: auto; // 710px;
  padding-bottom: 20px;
  margin: 0 auto;
}
.emailcanvas .btn-container {
  padding-bottom: 30px;
}
.emailcanvas label {
  margin-bottom: 20px;
}
#providetomail {
  margin-left: 30px;
}
.emailcanvas ul {
  display: flex;
  margin-top: -64px;
}
.emailcanvas .emailli {
  list-style: none;
  margin-left: 20px;
}
.emailcanvas .emailblock {
  background-color: #aaabac;
  padding: 5px 5px;
  width: auto;
  height: auto;
  margin-left: 12px;
  position: relative;
  top: 17px;
}
.emailcanvas .xout {
  background-color: white;
  cursor: pointer;
}
.mmailbox {
  background-color: #55555512;
  width: 100%;
  position: relative;
  z-index: 3000000000;
  top: -35px;
}
.mmailbox #hiddenmail {
  display: none;
}
.emailcanvas .selectbox {
  margin-top: -10px;
}
.inputvalholder {
  display: none;
  justify-content: flex-start;
}
.listGroupSec {
  display: none;
}
.listGroupSec .card .accordhead {
  display: flex;
  flex-direction: row-reverse;
  border-style: solid;
  border-width: 1px;
  border-color: #606565b0;
}
.listGroupSec .card .caret {
  text-align: right;
  width: 100px;
}
.listGroupSec .card .grp-name {
  width: 100%;
  margin: 0 auto;
}
.listGroupSec .card .grp-name p {
  text-align: center;
}
.listGroupSec .accordionbottom {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-style: solid;
  border-width: 1px;
  border-color: #0433;
  display: flex;
}
.listGroupSec .providminicard {
  display: flex;
  flex-direction: row-reverse;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  flex-direction: row-reverse;
  padding: 11px;
  margin-bottom: 3px;
}
.listGroupSec #accord-caret {
  cursor: pointer;
}
.listGroupSec #accord-caret:hover {
  color: #4553;
}
.listGroupSec .groupcanvas .card {
  display: flex;
  flex-direction: column;
}
.listGroupSec .subnavcontainer {
  display: none;
  flex-direction: column;
  width: 248px;
  margin-left: -153px;
  border-style: ridge;
  padding: 11px;
}
.listGroupSec #elipse {
  cursor: pointer;
}
.listGroupSec .closecanvas {
  display: none;
}
.listGroupSec .creategrpcanvas {
  display: none;
}
.listGroupSec .groupcanvas {
  display: none;
}
.accordionbottom {
  display: none;
}
.smsconferencecanvas {
  display: none;
}
.listGroupSec .accordionbottom {
  display: none;
}
.groupemailcecanvas {
  display: none;
}
#sbmttxtconfbtn {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;
}
#smsconferencebox {
  width: 650px;
  height: 220px;
}
#smsconferencephone {
  width: 425px;
  height: 45px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
}
.smsconferencecanvas .container {
  padding: 10px;
  display: flex;
  text-align: center;
}
.groupemailcecanvas .container {
  padding: 10px 100px;
  display: flex;
  text-align: center;
}
#emailform {
  border-style: solid;
  border-width: 1px;
  border-color: #003330;
}
#conferenceEmail {
  width: 425px;
  height: 45px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
}
#emailconferencebox {
  width: 650px;
  height: 220px;
}
#sbmtemailconfbtn {
  margin-top: 15px;
  margin-bottom: 15px;
}
.smsconferencecanvas #closeconfcallbtn {
  margin-left: 15px;
}
#groupemailcancelbtn {
  margin-left: 15px;
}
.prvtxtbox {
  height: 42px;
}
.status-active {
  display: none;
  background-color: #70a50d;
  color: #ffffff;
  font-size: 17px;
}
.status-nonactive {
  display: none;
  background-color: #f12f4f;
  color: #ffffff;
  font-size: 17px;
}
// .form-container {
//   display: flex;
//   flex-wrap: wrap;
//   padding: 0px 20%;
// }
// .form-container input {
//   width: 95%;
//   height: 45px;
// }
.nurseSettingSec {
  width: 100%;
  height: auto;
  display: none;
}
.nurseSettingSec form {
  display: flex;

  align-items: left;
  flex-direction: column;
}
.nurseSettingSec .horizontal {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: start;
}
.nurseSettingSec .vertical {
  display: flex;
  flex-direction: column;
}
.h-vertical {
  display: flex;
  flex-direction: column;
}
.setting-container {
  max-width: 700px;
}
#savesettingbtn {
  margin-right: 20px;
}
.nurseSettingSec select {
  margin-left: 20px;
  margin-bottom: 20px;
  width: 265px;
  border-radius: 6px;
  height: 32.5px;
}
/*End Keyon Provider CSS*/
@media only screen and (min-width: 1024px) {
}
@media only screen and (min-width: 1024px) {
  #provid-emailmsg {
    width: 400px;
  }
  .result-list .emailcanvas .container {
    width: 655px;
  }
  .groupemailcecanvas .container {
    padding: 10px 100px;
  }
  #conferenceEmail {
    margin: 20px;
  }
  #emailconferencebox {
    width: 100%;
  }
  .icon .desktopTel {
    display: flex;
  }
  .icon .mobileTel {
    display: none;
  }
  .emailcanvas .container textarea {
    width: 485px;
    height: 175px;
  }
  #smsconferencebox {
    width: 650px;
  }
  #smsconferencephone {
    width: 425px;
    margin: 20px;
  }
}
@media only screen and (max-width: 768px) {
  .result-list {
    width: 100%;
  }
}
@media only screen and (min-width: 360px) {
  #smsconferencephone {
    width: 100%;
    margin: 0px;
  }
  #smsconferencebox {
    width: 100%;
  }
  .d-option {
    display: none;
  }
  .icon .desktopTel {
    display: none;
  }
  .icon .mobileTel {
    display: flex;
  }
  #provid-emailmsg {
    width: 280px;
  }
  .emailcanvas .container {
    width: 340px;
  }
  .groupemailcecanvas .container {
    padding: 0px;
  }
  #conferenceEmail {
    margin: 10px 0px;
    width: 100%;
  }
  #emailconferencebox {
    width: 100%;
  }
}
</style>
